import React from 'react';
import { Modal, Button } from 'antd';

export default class ChooseFolioModal extends React.Component {
	render() {
		
		let i = 0

		return (
			<Modal visible={this.props.visible} onCancel={this.props.onCancel} footer={null}>
				There are a few people who can log in using this email address, please choose who you would like to continue as:
				<br />
				{
					this.props.folios.map(folio =>
					<div key={folio.FolioId} className="withSpacing">
						<Button id={i++} onClick={this.props.onChoose.bind(this, folio.FolioId)}>
							Continue as {folio.folForeName+' '+folio.folSurName}
						</Button>
					</div>
				)}
				To switch between these profiles, please log out and back in. <br /> <br /> To log in as more than one of these users at once, you must use a separate device, browser, or private browsing session. Please do not try to log in both users in the same browser (such as in a new tab or window).
			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/Login/ChooseFolioModal.jsx